/* eslint-disable no-useless-escape */
export const nonAccentVietnamese = (str: string) => {
  str = str.toLowerCase()
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a')
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e')
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i')
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o')
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u')
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y')
  str = str.replace(/đ/g, 'd')
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, '')
  str = str.replace(/\u02C6|\u0306|\u031B/g, '')
  return str.replace(/[^a-z0-9\_\.][\\\[\]\`^]?/g, '')
}

export const nonAccentVietnameseWithSpace = (str: string) => {
  str = str.toLowerCase()
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a')
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e')
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i')
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o')
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u')
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y')
  str = str.replace(/đ/g, 'd')
  // Remove combining marks
  str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  // Remove additional unwanted characters while keeping underscores, periods, and spaces
  return str.replace(/[^a-z0-9 _\.]/g, '')
}

/**
 * Loại bỏ tiền tố hành chính (Quận, Huyện, Thị xã, Thành phố, Tỉnh, Phường, Xã...)
 * khỏi tên địa danh khi phần còn lại bắt đầu bằng chữ cái.
 * Giữ nguyên nếu phần còn lại bắt đầu bằng số (ví dụ: "Quận 1" → "Quận 1").
 *
 * @example
 * removeAreaPrefix('Quận Ba Đình')     // => 'Ba Đình'
 * removeAreaPrefix('Quận 1')           // => 'Quận 1'
 * removeAreaPrefix('Huyện Đông Anh')   // => 'Đông Anh'
 * removeAreaPrefix('Tỉnh Hà Nam')      // => 'Hà Nam'
 * removeAreaPrefix('Thành Phố Hà Nội') // => 'Hà Nội'
 * removeAreaPrefix('Phường Bến Nghé')  // => 'Bến Nghé'
 * removeAreaPrefix('Xã Vĩnh Phúc')     // => 'Vĩnh Phúc'
 * removeAreaPrefix('Hà Nội')           // => 'Hà Nội'
 */
export const removeAreaPrefix = (name: string): string => {
  return name
    .replace(
      /^(Tỉnh|Thành [Pp]hố|Thủ [Đđ]ô|Quận|Huyện|Thị [Xx]ã|Thị [Tt]rấn|Phường|Xã)\s+(?!\d)/i,
      ''
    )
    .trim()
}
